<template>
  <div class="post-list-item-content">
    <div class="meta">
      <div class="title">
        {{ itemPackTitle }}
        <span class="statistics">{{ itemPackNodeStatistics }}</span>
      </div>
      <div class="duration">{{ item.video.duration }}</div>
    </div>
    <div class="header">
      <div class="action">
        <NodeCompleteAction :node="item" size="16" />
      </div>
      <div class="text">
        <router-link class="link" :to="itemLinkTo">
          {{ item.title }}
        </router-link>
      </div>
    </div>
    <div class="footer">
      <router-link :to="itemSeriesLinkTo" class="link">
        {{ item.series.title }} （ 共 {{ item.series.packCount }} 集 ）
      </router-link>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import NodeCompleteAction from '@/node/components/node-complete-action';

export default defineComponent({
  name: 'PostListItemContent',

  /**
   * 属性
   */
  props: {
    item: {
      type: Object,
    },
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    itemLinkTo() {
      return { name: 'postShow', params: { postId: this.item.id } };
    },

    itemPackTitle() {
      return `第${this.item.pack.packIndex + 1}集 · ${this.item.pack.title}`;
    },

    itemPackNodeStatistics() {
      return `( ${this.item.nodeIndex + 1}  / ${this.item.pack.nodeCount} )`;
    },

    itemSeriesLinkTo() {
      return { name: 'seriesShow', params: { seriesId: this.item.series.id } };
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {
    NodeCompleteAction,
  },
});
</script>

<style scoped>
@import './styles/post-list-item-content.css';
</style>
